import { PROPERTY_GRID_SUBJECT_PROPERTY } from '@aloft/toolkit-shared';

import { useWatch } from 'react-hook-form';

import { PropertyGridFieldProps } from '../types.ts';
import { resolveFieldName } from '../utils.tsx';

type UsePropertyFieldProps = Pick<PropertyGridFieldProps, 'columnIndex' | 'control' | 'getValues'> &
  Required<Pick<PropertyGridFieldProps, 'isArv'>> & {
    field: Pick<PropertyGridFieldProps['field'], 'fieldName' | 'toDisplayValue'>;
  };

export const usePropertyField = ({
  columnIndex,
  control,
  getValues,
  isArv,
  field,
}: UsePropertyFieldProps) => {
  const { fieldName: rawFieldName, toDisplayValue } = field;

  const propertyId = getValues(`columns.${columnIndex}.propertyId`);
  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;

  const { fieldName, propertyDataFieldName, selectedSourceFieldName } = resolveFieldName(
    rawFieldName,
    columnIndex,
    isSubject,
    isArv,
  );

  const value = useWatch({ control, name: propertyDataFieldName }) as string | undefined;
  const displayValue = toDisplayValue ? toDisplayValue(value, propertyId) : value;

  return {
    propertyId,
    isSubject,
    fieldName,
    propertyDataFieldName,
    selectedSourceFieldName,
    value,
    displayValue,
  };
};
